import { render, staticRenderFns } from "./User_center.vue?vue&type=template&id=700176ee&scoped=true&"
import script from "./User_center.vue?vue&type=script&lang=js&"
export * from "./User_center.vue?vue&type=script&lang=js&"
import style0 from "./User_center.vue?vue&type=style&index=0&id=700176ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700176ee",
  null
  
)

export default component.exports